export { EloBankWireDeIcon } from './bank-wire-de-icon'
